const Select = ({ value, handleContinentChange }) => {
  return (
    <div className="w-[200px]">
      <select
        name="continent"
        id="continent"
        value={value}
        onChange={handleContinentChange}
        className="w-full px-4 py-3 rounded-xl bg-white dark:bg-containerColor shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all cursor-pointer"
      >
        <option value="All">All Regions</option>
        <option value="Africa">Africa</option>
        <option value="Americas">Americas</option>
        <option value="Asia">Asia</option>
        <option value="Europe">Europe</option>
        <option value="Oceania">Oceania</option>
      </select>
    </div>
  );
};

export default Select;
